import { axios } from 'lib/axios';


export const confirmEmail = ({ code }) => {
  return axios.post(`/users/confirm/${code}`);
};
